import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { FormattedDate } from 'react-intl';

import Bin from '../assets/Bin.svg';
import styles from '../shared.scss';
import getDateDetails from '../utils/getDateDetails';
import type { WallPosts } from '../utils/normalizeWallPosts';

interface Props {
  comment: WallPosts;
  userId?: string;
  handleDeleteWallPost?: (id: number) => void;
  canManage: boolean;
  loading: boolean;
}

const Comment: React.FC<Props> = (props) => {
  const { comment, userId, canManage, handleDeleteWallPost, loading } = props;
  const { isSameYear, isSameDay, isSameMonth, isYesterday } = getDateDetails(comment.created);
  const hideDayAndMonth = (isSameYear && isSameMonth && isSameDay) || isYesterday;
  const isOwnPost = userId === comment.userId;
  const canDelete = canManage || isOwnPost;

  const handleDelete = () => {
    if (comment.id) handleDeleteWallPost?.(comment.id);
  };

  const showDelete = canDelete && !loading;

  return (
    <div className={styles.wallCommentContainer}>
      <div key={comment.id} className={styles.wallComment}>
        <div className={styles.info}>
          <span className={userId === comment.userId ? styles.usernameOwn : styles.username}>
            {comment.userId}
          </span>
          <span className={styles.date}>
            {isYesterday && <span>Yesterday, </span>}
            <FormattedDate
              value={comment.created}
              day={hideDayAndMonth ? undefined : '2-digit'}
              month={hideDayAndMonth ? undefined : 'short'}
              year={isSameYear ? undefined : 'numeric'}
              hour="2-digit"
              minute="numeric"
              hour12={false}
            />
          </span>
        </div>
        <p className={styles.content}>{comment.content}</p>
      </div>
      {showDelete && (
        <StarsButton
          className={styles.deleteComment}
          onClick={handleDelete}
          block
          icon={<Bin />}
          variant="text"
          disabled={loading}
          type="submit"
        />
      )}
    </div>
  );
};

export default Comment;
